import React, { useState, useEffect, useRef } from 'react';
import {
  ExpandableDescription,
  DescriptionText,
  ExpandButton,
  InfoTitle
} from '../styles/EventSidebar.styles';

const EventDescription = ({ description, eventId }) => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const [shouldShowButton, setShouldShowButton] = useState(false);
  const textRef = useRef(null);

  // Reset descrizione quando cambia evento
  useEffect(() => {
    setIsDescriptionExpanded(false);
  }, [eventId]);

  // Controlla se il testo ha più di 3 righe
  useEffect(() => {
    if (textRef.current && description) {
      // Crea un elemento temporaneo per misurare
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.visibility = 'hidden';
      tempDiv.style.width = textRef.current.offsetWidth + 'px';
      tempDiv.style.fontSize = window.getComputedStyle(textRef.current).fontSize;
      tempDiv.style.fontFamily = window.getComputedStyle(textRef.current).fontFamily;
      tempDiv.style.lineHeight = '1.4';
      tempDiv.innerHTML = `<p>${description}</p>`;
      
      document.body.appendChild(tempDiv);
      
      const lineHeight = parseFloat(window.getComputedStyle(tempDiv).lineHeight);
      const totalHeight = tempDiv.offsetHeight;
      const lines = Math.ceil(totalHeight / lineHeight);
      
      document.body.removeChild(tempDiv);
      
      setShouldShowButton(lines > 3);
    }
  }, [description]);

  if (!description) return null;

  return (
    <ExpandableDescription>
      <InfoTitle>Descrizione</InfoTitle>
      <DescriptionText 
        ref={textRef}
        isExpanded={isDescriptionExpanded}
        onClick={() => shouldShowButton && setIsDescriptionExpanded(!isDescriptionExpanded)}
        style={{ cursor: shouldShowButton ? 'pointer' : 'default' }}
      >
        <p>{description}</p>
      </DescriptionText>
      
      {shouldShowButton && (
        <ExpandButton 
          onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
        >
          {isDescriptionExpanded ? (
            <>
              <span>📤</span> Mostra meno
            </>
          ) : (
            <>
              <span>📥</span> Leggi tutto
            </>
          )}
        </ExpandButton>
      )}
    </ExpandableDescription>
  );
};

export default EventDescription;
